export const URLS_CONST = {
    STAGING_HOST:'staging.litmusworld.com',
    PROD_HOST:'dashboard-india.litmusworld.com',
    FIELD_BRAND_ID: 'brand_id',
    ROUTE_LOGIN: '/login',
    MANAGER_ID:'manager_id',
    ACCOUNT_ID:'account_id',
    BRAND_ID:'brand_id',
    SELECTED_ID:'selected_id',
    FEED_ID:'feed_id',
    LITMUS_LOGO_URL:'assets/images/litmusworld.svg',
    FROM_DATE: 'from',
    TO_DATE: 'to',
    PARENT_KEY: 'parent_key',
    PARENT_VALUE: 'parent_value',
    HIERARCHY_LEVEL: 'level',
    CUSTOM_FILTER_LIST: 'custom_filter_list',
    SEARCH_TEXT: 'search_text',
    LIMIT: 'limit',
    PAGE_NUMBER:'page_number',
    GROUP_KEY:'group_key',
    GROUP_VALUE: 'group_value',
    MANAGER_TYPE: 'manager_type',
    SHOP_ID:'shopId',
    UUID: 'uuid',
    CATEGORY_ID: 'category_id',
    PARENT_ID: 'parent_id',
    LEVEL: 'level',
    TYPE: 'type',
    IS_EXCLUDE_FROM_ANALYTICS:'is_excluded_from_analytics',
    
    
}